import { SelfAssessmentNew, SelfAssessmentT2 } from "../self-assessmentT2/self-assessmentT2";
import { SelfAssessment } from "./self-assessment";
import { BulkSelfAssessment } from "./self-assessment";

export class BulkSelfUpdateModel {
  itemIds: Array<number>;
  selfAssessment: BulkSelfAssessment;

  constructor() {
    this.itemIds = [];
    this.selfAssessment = new BulkSelfAssessment();
  }
}
export class BulkSelfUpdateModelT2 {
  itemIds: Array<number>;
  selfAssessment: SelfAssessmentNew;

  constructor() {
    this.itemIds = [];
    this.selfAssessment = new SelfAssessmentNew();
  }
}